import { TextField } from "@mui/material";
import { FormFieldController } from "@src/appV2/PlacementCandidates/components/FormFieldController";
import { type Control, useWatch } from "react-hook-form";

import { type RequirementMappingFormValues } from "../types";

interface LevelConfirmationFieldProps {
  control: Control<RequirementMappingFormValues>;
}

export function LevelConfirmationField(props: LevelConfirmationFieldProps) {
  const { control } = props;

  const level = useWatch({ control, name: "level" });

  return (
    <FormFieldController
      required
      name="levelConfirmation"
      control={control}
      label="Confirm"
      helperText="Type the mapping level to confirm"
      sx={{ mb: 2 }}
      render={(field) => <TextField {...field} placeholder={level} autoComplete="off" />}
    />
  );
}
